<app-carousel-flat
  [items]="events"
  [heading]="'Popular Events'"
  [viewAllTitle]="'events' | t"
  link="/results"
  [itemsPerSlide]="itemsPerSlide"
  [showIndicators]="isMobile"
  [showPagination]="!isMobile"
>
  <ng-template let-item="item">
    <app-event
      [title]="('open' | t) + ' ' + item.event_name"
      [event]="item"
      [minified]="true"
      [background]="false"
      [inline]="true"
      [showViewButton]="false"
      [hasClickEvent]="true"
      (eventClicked)="eventClicked.emit(item)"
    ></app-event>
  </ng-template>
</app-carousel-flat>
